<template>
  <div class="view marketing recipients">recipients</div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped></style>
